(function(angular){
	'use strict';

	angular
		.module('additionalInvestmentReviewModule')
		.controller('ReviewRepeatOrderController', [
			'$timeout',
			'$window',
			'CheckoutFactory',
			'globalConfig',
			ReviewRepeatOrderControllerFunction
		]);

	function ReviewRepeatOrderControllerFunction(
		$timeout,
		$window,
		CheckoutFactory,
		globalConfig){

		var reviewOrder = this;

		function buildPayload() {
			var payload = {};

			if(angular.isDefined(reviewOrder.reitDocumentRevisionIds)) {
				payload.reitDocumentRevisionIds = reviewOrder.reitDocumentRevisionIds;
			}

			return payload;
		}

		function submitForm() {
			$window.document.getElementById('reviewOrderForm').submit();
		}

		reviewOrder.placeOrderAndRedirect = function() {
			CheckoutFactory.placeOrder(buildPayload(), reviewOrder.reitInvestmentOrderGroupId)
				.then(function(data) {
					reviewOrder.reitInvestmentOrderGroupId = data.orderGroupId;
					$timeout(function() {
						submitForm();
					});
				})
				.catch(function() {
					reviewOrder.formSubmitted = false;
				});
		};

		reviewOrder.$onInit = function() {
			angular.extend(reviewOrder, globalConfig);

			CheckoutFactory.getOrderGroup(reviewOrder.reitInvestmentOrderGroupId)
				.then(function(orderGroup) {
					reviewOrder.orderGroup = orderGroup;
				});
		};
	}
})(window.angular);